import { BASEURL, checktoken, headers } from '../../utils/helper'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError, toastSuccess } from './other.slice';
import axios from 'axios';

const initialState = {
    data: [],
    error: null,
    sidebar: true,
    loading: false,
}

export const InsuranceTypeCreate = createAsyncThunk('InsuranceTypeCreate', async ({ data, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.post(`${BASEURL}/admin/create/insurance/type`, data,
            { headers: headers() })
            .then((res) => {
                dispatch(InsuranceTypeList({}))
                if (res.data?.success) {
                    dispatch(toastSuccess(res.data?.message))
                }
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})
export const InsuranceTypeDelete = createAsyncThunk('InsuranceTypeCreate', async ({ id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.delete(`${BASEURL}/admin/delete/insurance/type/${id}`,
            { headers: headers() })
            .then((res) => {
                dispatch(InsuranceTypeList({}))
                if (res.data?.success) {
                    dispatch(toastSuccess(res.data?.message))
                }
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const InsuranceTypeList = createAsyncThunk('InsuranceTypeList', async ({ data, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/insurance/type/list`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const InsurancetypeSlice = createSlice({
    name: 'InsurancetypeSlice',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addCase(InsuranceTypeList.pending, (state, action) => {
            state.loading = true
            state.data = []
            return state
        })
        builder.addCase(InsuranceTypeList.fulfilled, (state, action) => {
            state.loading = false
            state.data = action.payload.data
            return state
        })
        builder.addCase(InsuranceTypeList.rejected, (state, action) => {
            state.loading = false
            state.data = []
            state.error = 'Error occured'
        })
        builder.addCase('LOGOUT', () => initialState)
    }
})

export default InsurancetypeSlice.reducer